<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col md="12">
        <v-card flat class="rounded-lg pa-4">
          <v-card-title>
            <div class="headline font-weight-bold font--text">
              My Account Settings
            </div>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card flat class="rounded-lg pa-4">
          <v-card-text>
            <div class="d-flex flex-row">
              <div class="mr-4">
                <v-icon style="font-size: 60px" color="#F1F2F2"
                  >mdi-circle</v-icon
                >
              </div>
              <div class="d-flex flex-column align-self-center">
                <div class="headline font-weight-bold font--text">
                  {{ userprofile.email }}
                </div>

                <p class="mb-0" style="font-size: 12px; color: #a5b3bf">
                  Member since
                  {{
                    $moment(new Date(userprofile.createdate)).format(
                      "DD/MM/YYYY"
                    )
                  }}
                </p>

                <p class="mb-0" style="font-size: 12px;">
                  <b>Sales:</b> {{ currentOrg ? (currentOrg.sales && currentOrg.sales.fullname ? currentOrg.sales.fullname : '-') : '-' }}
                </p>

                <!-- postpaid / prepaid -->
                <p v-if="service_type !== 'undefined'" :style="{marginTop: '8px', display: 'flex', alignItems: 'center', color: service_type === 'postpaid' ? '#27AE60' : '#A5B3BF'}">
                  <img :src="service_type === 'postpaid' ? '/postpaid.png' : '/prepaid.png'" alt="postpaid-logo" :style="{marginRight: '4px'}" />
                  {{uppercaseFirstLetter(service_type)}}
                </p>
              </div>
              <v-spacer />
              <div class="d-flex align-self-center">
                <v-btn
                  @click="
                    () => {
                      opendialogchangepassword = true;
                    }
                  "
                  depressed
                  outlined
                  height="50"
                  width="150"
                  class="secondary--text"
                  >Change Password</v-btn
                >
                <div style="height: auto; width: 28px"></div>
                <v-btn
                  @click="
                    () => {
                      memberselected = userprofile;
                      opendialogeditprofile = true;
                    }
                  "
                  depressed
                  height="50"
                  width="150"
                  class="secondary"
                  >Edit Profile</v-btn
                >
              </div>
            </div>
          </v-card-text>
          <v-card-text>
            <v-row>
              <v-col class="d-flex">
                <v-icon
                  class="mr-4"
                  style="font-size: 60px; visibility: hidden"
                  color="#F1F2F2"
                  >mdi-circle</v-icon
                >
                <p>
                  <b>Full Name:</b><br />
                  {{ userprofile.fullname }}
                </p>
              </v-col>

              <v-col class="justify-left d-flex">
                <p>
                  <b>Phone Number:</b><br />
                  {{ userprofile.phone }}
                </p>
              </v-col>

              <v-col class="justify-left d-flex">
                <p>
                  <b>Address:</b><br />
                  {{ userprofile.address }}
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12"
        :style="{ 'display': isShowSshGrid ? '': 'none' }"
      >
        <v-card flat class="rounded-lg pa-4">
          <v-card-title>
            <div class="headline font-weight-bold font--text">
              SSH Keys
            </div>
            <v-btn
              id="CreateNewAttach"
              depressed
              class="secondary mb-5 ml-auto"
              height="50"
              width="150"
              @click="
                () => {
                  userId = userprofile.id;
                  opendialogaddssh = true;
                }
              "
              ><span class="fz-14">Add SSH Key</span></v-btn
            >
          </v-card-title>
          <div>
            <v-container class="px-4">
              <template>
                <v-data-table
                  :headers="table.headers"
                  :items="sshkeys"
                  :items-per-page="10"
                  :server-items-length="pagination.count"
                  :options.sync="options"
                  hide-default-footer
                >
                  <template #[`item.fingerprint`]="{ item }">
                    <p>
                      {{ item.fingerprint !== "" ? item.fingerprint : "-" }}
                      <span
                        v-if="item.fingerprint"
                        @click="copyToClipBoard(item.fingerprint)"
                        class="primary--text pr-3 delete ml-4"
                        >Copy</span
                      >
                    </p>
                  </template>
                  <template #[`item.action`]="{ item }">
                    <span
                      @click="
                        () => {
                          ssh = item.id;
                          userId = userprofile.id;
                          openDialogDeleteSsh = true;
                        }
                      "
                      class="error--text pr-3 delete ml-4"
                      >Delete</span
                    >
                    <span
                      @click="
                        () => {
                          sshItem = item;
                          openDialogUpdate = true;
                        }
                      "
                      class="primary--text pr-3 delete ml-4"
                      >Edit</span
                    >
                  </template>
                  <template #footer="{ props }">
                    <custom-footer-datatable
                      @input="
                        (val) => {
                          options = { ...options, ...val };
                        }
                      "
                      :props="props"
                    />
                  </template>
                </v-data-table>
              </template>
            </v-container>
          </div>
        </v-card>
      </v-col>
       <v-col md="12"
          :style="{ 'display': isShowSshGrid ? '': 'none' }"
        >

      <v-card class="mt-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" class="d-flex align-self-center"
            ><h3>Multi-factor Authentication</h3></v-col
          >
          <v-col cols="12" md="8">
            <v-row>
              <v-col
                md="10"
                class="d-flex align-self-center justify-md-end justify-sm-center"
                ><h3>Enroll New Code</h3>
                </v-col
              >
              <v-col md="2" class="d-flex justify-start pr-0 pt-1"
                ><v-switch
                  class="mt-0"
                  id="enrollnewMfa"
                  color="primary"
                  v-model="enrollnewMfa"
                  inset
                  hide-details
                  @change="openDialogPwMfa"
                ></v-switch
              ></v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="openexpandMfa">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-card-text>
              <v-row>
                <v-col md="5" style="padding-top: 0;padding-right: 0px;">
                  <p
                    style="
                      justify-content: space-between;
                      align-items: center;
                      font-size: 20px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 27px;
                      margin-bottom: 30px;
                      text-align: center;
                    "
                  >
                    Scan this QR Code With Your Authenticator App
                    <p class="qr-code-container">
                      <qrcode-vue :value="urlQr" :size="200" />
                    </p>
                  </p>
                </v-col>
                <v-col md="7" style="padding-top: 0; padding-bottom: 30px;" class="mt-1">
                  <b class="fz-18">Keep This Account Name and Secret Key Safe for Backup in Case You Need It later.</b> <br>
                  <br>
                  <b>Account Name :</b> <br>
                  {{ email }} 
                    <v-icon class="fz-16" icon="mdi-content-copy"  @click="() => copyClipboard(email)"></v-icon>
                  <br>
                  <p style="padding-top: 10px;"><b>Secret Key :</b> <br> 
                    {{ secretQr }}
                    <v-icon class="fz-16" icon="mdi-content-copy"  @click="() => copyClipboard(secretQr)"></v-icon>
                  </p>
                  <p style="padding-top: 10px;"><b>Key Type :</b> <br> 
                    Time Based
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text class="justify-center d-flex py-0">
              <p class="font-weight-bold mb-1">Please enter the generated security code below*</p>
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <v-row>
                <v-col>
                    <v-otp-input style="justify-content: center;"
                      ref="otpInput"
                      input-classes="otp-input"
                      :conditionalClass="['one', 'two', 'three', 'four', 'five', 'six']"
                      separator=""
                      inputType="letter-numeric"
                      :num-inputs="6"
                      v-model:value="otp"
                      :should-auto-focus="true"
                      :should-focus-order="true"
                      @on-change="otpOnChange"
                      @on-complete="otpOnComplete"
                  />
                  <p class="text-error text-sm mt-1">{{ $votp.otp.$errors.length ? $votp.otp.$errors[0].$message : '' }}</p>
                </v-col>
              </v-row>

            </v-card-text>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-btn
                    data-qa="btnCancel"
                    depressed
                    height="45"
                    block
                    class="text-white" 
                    color="accent"
                    @click="onClose()"
                  >Cancel</v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    data-qa="btnConfirmPassword"
                    depressed
                    height="45"
                    block
                    color="primary"
                    variant="flat"
                    @click="confirmTotp"
                  >Confirm</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
       </v-col> 
    </v-row>
    <dialogEditProfile
      :userselected="memberselected"
      v-if="memberselected && opendialogeditprofile"
      v-model="opendialogeditprofile"
    />
    <dialodchangepassword
      v-if="opendialogchangepassword"
      v-model="opendialogchangepassword"
    />
    <dialogupdatessh
      v-if="sshItem && openDialogUpdate"
      :ssh="sshItem"
      v-model="openDialogUpdate"
      @close="openDialogUpdate = false"
    />
    <dialogcreatessh
      :userid="userId"
      v-if="userId && opendialogaddssh"
      v-model="opendialogaddssh"
      @close="opendialogaddssh = false"
    />
    <dialogdeletessh
      :ssh-id="ssh"
      :user-id="userId"
      v-if="ssh && userId && openDialogDeleteSsh"
      v-model="openDialogDeleteSsh"
      @close="openDialogDeleteSsh = false"
    />
    <dialogPw 
      :show.sync="openDialogPw"
      @close="enrollnewMfa = false"
      @sendResponse="sendResponse"
    ></dialogPw>
  </v-container>
</template>
<script>
import { ref, reactive, onMounted, watch } from "@vue/composition-api";
import {
  useNamespacedState,
  useNamespacedActions,
} from "vuex-composition-helpers";
import dialodchangepassword from "./dialogChangePassword";
import dialogEditProfile from "./dialogEditProfile";
import { PROFILE } from "./namespace";
import dialogcreatessh from "./dialogCreateSsh.vue";
import dialogdeletessh from "./dialogDeleteSsh.vue";
import dialogupdatessh from "./dialogUpdateSsh.vue";
import localStorage from "@/lib/localstorage";
import { useVuelidate } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import dialogPw from "./dialog-password.vue";
import QrcodeVue from "qrcode.vue";
import getPrivilagesWithFallback from "@/lib/getPrivilages";

export default {
  components: {
    dialodchangepassword,
    dialogEditProfile,
    dialogcreatessh,
    dialogupdatessh,
    dialogdeletessh,
    dialogPw,
    QrcodeVue
  },
  setup() {
    const { member, userprofile } = useNamespacedState("ROLEPERMISSION", [
      "member",
      "userprofile",
    ]);

    const { fetchsshkeys , validateTotp} = useNamespacedActions(PROFILE, [
      "fetchsshkeys",
      "validateTotp"
    ]);
    const { showSuccessToast } = useNamespacedActions("HOMEPAGE", [
      "showSuccessToast",
    ]);
    const { fetchUserProfile } = useNamespacedActions("ROLEPERMISSION", [
      "fetchUserProfile",
    ]);
    const { sshkeys, pagination } = useNamespacedState(PROFILE, [
      "sshkeys",
      "pagination",
    ]);

    const openDialogDeleteSsh = ref(false);

    const table = reactive({
      headers: [
        { text: "Region", value: "region", sortable: false },
        { text: "Project", value: "project", sortable: false },
        { text: "Name", value: "name", sortable: false },
        { text: "Fingerprint", value: "fingerprint", sortable: false },
        { text: "Action", value: "action", sortable: false, align: "center" },
      ],
    });
    const options = ref({
      page: 1,
      itemsPerPage: 10,
      rowsPerPage: 10,
      search: "",
      sortBy: [],
      sortDesc: [],
    });

    const sshselected = ref("");
    const userId = ref("");
    const ssh = ref("");
    const sshItem = ref({});
    const openDialogPw = ref(false)
    const openexpandMfa = ref(false)
    const enrollnewMfa = ref(false)
    const otp = ref('')
    const urlQr = ref("");
    const secretQr = ref("");
    const email = localStorage.getItem("username");
    const uid = localStorage.getItem("userId");

    const copyToClipBoard = (data) => {
      window.navigator.clipboard.writeText(data);
      showSuccessToast("Clipboard Copied!");
    };

   
    const openDialogPwMfa = (value) => {
      openDialogPw.value = true
    }
    const $votp = useVuelidate({
        otp: { 
          required: helpers.withMessage("couldn't be empty.", (val) => {
            return val;
          }),
        },
      }, {
        otp
    });
    const otpOnChange = (val) => {
        otp.value = val
    }
    const otpOnComplete = (val) => {
        otp.value = val
    }
    const otpInput = ref(null)
    const confirmTotp = async () => {
      $votp.value.$touch();
      if ($votp.value.$errors.length) return;
      let payload, resp 
      payload = {
          user_id: uid.replaceAll('"', ""),
          totp: otp.value,
          secret: secretQr.value,
          url: urlQr.value
      };
      resp = await validateTotp(payload)
      if(resp.status == 200){
        enrollnewMfa.value = false
        openexpandMfa.value = false
      } else {
        otp.value = '';
        otpInput.value && otpInput.value.clearInput && otpInput.value.clearInput();
        $votp.value.$reset(); 
      }
    };
    
    const sendResponse = (event) => {
      urlQr.value = event.urlQr;
      secretQr.value = event.secretQr;
      // openDialogPw.value = false;
      openexpandMfa.value = true;
      enrollnewMfa.value = true;
    };

    const updateSwitchMfa = () => {
      enrollnewMfa.value = false
    }
    const onClose = () => {
      openexpandMfa.value = false
      enrollnewMfa.value = false
    };
    watch(
      options,
      (val) => {
        fetchsshkeys(userprofile.value.id, options).catch(() => {});
      },
      { deep: true }
    );

    let isShowSshGrid = ref(true);
    onMounted(async () => {
      fetchUserProfile().then((profile) => {
        fetchsshkeys(profile.id, options).catch(() => {});
      });
      const role = localStorage.getItem('role')
      if (role !== "Superadmin" || role === 'Customer-Care' || role === 'GodMode') {
        const privilages = await getPrivilagesWithFallback();
        privilages.map((x) => {
          let name = x.name.toLowerCase()
          if (x.disable && name == 'instance') {
            isShowSshGrid.value = false
          }
        })
      }
    });

    const Update = () => {
      return member.value.ref.update({
        name: member.value.name,
        email: member.value.email,
        phone: member.value.phone,
        address: member.value.address,
      });
    };
    return {
      userId,
      memberselected: ref(),
      opendialogeditprofile: ref(false),
      opendialogchangepassword: ref(false),
      userprofile,
      member,
      copyToClipBoard,
      Update,
      dialog: ref(false),
      table,
      sshkeys,
      opendialogaddssh: ref(false),
      openDialogDeleteSsh,
      sshselected,
      openDialogUpdate: ref(false),
      ssh,
      sshItem,
      options,
      pagination,
      isShowSshGrid,
      openDialogPw,
      openDialogQr: ref(false),
      openexpandMfa,
      enrollnewMfa,
      openDialogPwMfa,
      updateSwitchMfa,
      sendResponse,
      urlQr,
      secretQr,
      email,
      otp,
      otpOnChange,
      otpOnComplete,
      confirmTotp,
      $votp,
      onClose,
      uid
    };
  },
  computed: {
    service_type() {
      return localStorage.getItem('service_type')
    },
    currentOrg() {
      const json = localStorage.getItem('currentOrg')
      const obj = json && json !== 'undefined' ? JSON.parse(json) : {}
      return obj
    },
  },
  methods: {
    uppercaseFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  }
};
</script>
<style lang="scss" scoped>
.v-card__text {
  ::v-deep [type="button"].error--text {
    border: 2px solid red;
    background-color: transparent !important;
  }
  ::v-deep p {
    font-size: 12px;
  }
}
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
}
/* .otp-input-cloudeka-container div { */
.otp-input-container div {
    display: flex;
    justify-content: space-between;
    width: 100%; /* Mengatur lebar elemen agar menyesuaikan dengan lebar parent */
    max-width: 100%; /* Memastikan elemen tidak melebihi lebar parent */
    box-sizing: border-box; /* Memasukkan padding dan border ke dalam ukuran elemen */
    padding: 10px; /* Contoh padding, sesuaikan dengan kebutuhan */
  }
  .otp-input-container >>> div {
    display: flex;
    align-items: center;
    max-width: 10%;
    background-color: #f0f3f6;
    margin: 0px 3px;
  }
  .otp-input-container >>> input {
    width: 100% !important;
    height: 50px;
    text-align: center;
  }
  .otp-input-cloudeka {
    width: 80px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #cad6e1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    text-align: center;
  }
</style>
